module.exports = __webpack_public_path__ + "h5/img/bs_20.a4f0da8c.jpeg";